const ClothSize = [
    {
        size: "XS",
        price: 7999
    },
    {
        size: "S",
        price: 8999
    },
    {
        size: "M",
        price: 9999
    },
    {
        size: "L",
        price: 10999
    },
    {
        size: "XL",
        price: 11999
    }
]
export default ClothSize;